import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { rutaCondiciones } from "@/lib/legalPaths";

const TEXTOS: Record<string, { antes: string; enlace: string; pestanaNueva: string }> = {
  es: { antes: "Acepto las ", enlace: "condiciones de contratación", pestanaNueva: "(se abre en una pestaña nueva)" },
  en: { antes: "I accept the ", enlace: "terms and conditions", pestanaNueva: "(opens in a new tab)" },
  pt: { antes: "Aceito as ", enlace: "condições de contratação", pestanaNueva: "(abre num novo separador)" },
  fr: { antes: "J'accepte les ", enlace: "conditions générales", pestanaNueva: "(s'ouvre dans un nouvel onglet)" },
};

/** Texto de la casilla de condiciones de campamentos y cumpleaños, con enlace a ellas */
export const TermsLabel = () => {
  const { language } = useLanguage();
  const t = TEXTOS[language] || TEXTOS.es;
  return (
    <>
      {t.antes}
      <Link to={rutaCondiciones(language)} target="_blank" className="text-primary underline underline-offset-4">
        {t.enlace}
        <span className="sr-only"> {t.pestanaNueva}</span>
      </Link>
    </>
  );
};
